import { ValidationError } from 'WebmcpCore/errors';
import { z } from 'zod';

export function zodToJsonSchemaSafe(schema: z.ZodTypeAny): object {
  if (!(schema instanceof z.ZodObject)) {
    throw new ValidationError('WebMCP input top-level schema must be a z.object(...)');
  }
  return z.toJSONSchema(schema, { target: 'draft-7' }) as object;
}
